import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=1bab7e69&"
import script from "./MediaPreview.vue?vue&type=script&lang=ts&"
export * from "./MediaPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=1bab7e69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports